'use client';

import { useShallow } from 'zustand/react/shallow';
import dynamic from 'next/dynamic';
import type { JoinFlowContent } from 'services/generated/growth-content-service/models/JoinFlowContent';
import HeroSectionWrapper from '../HeroSectionWrapper/HeroSectionWrapper';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { EXPERIMENT_GCC_TRIAL_DEPOSIT } from '@/lib/constants/experiments';

const HowItWorks = dynamic(() => import('../howItWorks/howItWorks'), {
  ssr: false,
});

const Gen4Data = dynamic(() => import('../gen4Data/gen4Data'), { ssr: false });

const WhoopAppData = dynamic(() => import('../whoopAppData/whoopAppData'), {
  ssr: false,
});

const CoachingData = dynamic(() => import('../coachingData/coachingData'), {
  ssr: false,
});

interface LandingPageContentProps {
  isMobile: boolean;
  promoContent?: JoinFlowContent;
  skipMemSelection?: string;
  skipMemFamilySize?: string;
}

export default function LandingPageContent({
  isMobile,
  promoContent: propPromoContent,
  skipMemSelection,
  skipMemFamilySize,
}: LandingPageContentProps): React.JSX.Element {
  const { promoInfo, experimentVariants } = useSiteStore(
    useShallow((state) => ({
      promoInfo: state.promoInfo,
      experimentVariants: state.experimentVariants,
    })),
  );

  // TODO: Move this.
  const isJfHeroCarouselEnabled = Boolean(isMobile && !promoInfo?.affiliate);
  const gccTrialDepositExperimentVariant =
    experimentVariants[EXPERIMENT_GCC_TRIAL_DEPOSIT];

  return (
    <div className='flex w-full flex-col items-center bg-white'>
      {/* 
        Each of these is a <section> with an order-x class on it. 
        The footer CTA is in HeroSectionWrapper so it can use the logic. But is ordered last.
      */}
      <HeroSectionWrapper
        gccTrialDepositExperimentVariant={gccTrialDepositExperimentVariant}
        isMobile={isMobile}
        propPromoContent={propPromoContent}
        skipMemFamilySize={skipMemFamilySize}
        skipMemSelection={skipMemSelection}
      />
      <HowItWorks isJfHeroCarouselEnabled={isJfHeroCarouselEnabled} />
      <Gen4Data />
      <WhoopAppData />
      <CoachingData />
    </div>
  );
}
